/**
 * Picks a pixel ratio that keeps a canvas sharp but under a pixel budget.
 * Safari refuses canvases above ~16.7M pixels, and big canvases cost memory and battery everywhere.
 */
export function safeDpr(cssWidth: number, cssHeight: number, maxDpr: number, budget: number): number {
  const want = Math.min(window.devicePixelRatio || 1, maxDpr)
  const area = Math.max(1, cssWidth * cssHeight)
  return Math.max(0.5, Math.min(want, Math.sqrt(budget / area)))
}
